import { BaseModel } from "@/models/base";
import { API_URL_SERVICE } from "@/commons/config";
import {
  beneficiarioHandleRequest,
  beneficiarioHandleErrorRequest
} from "@/helpers/beneficiario-handle-request";
import { handleErrorResponse, handleResponse } from "@/helpers/handle-response";

import { Axios } from "axios-observable";
import axios, { AxiosResponse, AxiosRequestConfig, AxiosInstance } from "axios";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

export interface APIModel<T extends BaseModel> {
  body?: T;
  pageIndex?: number;
  pageSize?: number;
}

export class BeneficiarioBaseAPI<T extends BaseModel> {
  protected axios: Axios;
  protected apiUrl: string;
  protected graphqlUrl: string;

  constructor() {
    this.axios = this.buildAxiosInstance();
    this.apiUrl = API_URL_SERVICE;
    this.graphqlUrl = `${API_URL_SERVICE}/graphql`;
  }

  public getAll(): AxiosObservable<T[]> {
    return this.axios.get(`${this.apiUrl}`);
  }

  public paginator(model: APIModel<T>): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/find?` +
        `${this.getNumberPage(model.pageIndex)}&` +
        `${this.getNumberRegistries(model.pageSize)}`,
      model.body
    );
  }

  public show(id: number): AxiosObservable<T> {
    return this.axios.get(`${this.apiUrl}/${id}`);
  }

  public create(body: T): AxiosObservable<T> {
    return this.axios.post(`${this.apiUrl}/`, body);
  }

  public update(id: number, body: T): AxiosObservable<T> {
    return this.axios.put(`${this.apiUrl}/${id}`, body);
  }

  public delete(id: number): AxiosObservable<any> {
    return this.axios.delete(`${this.apiUrl}/${id}`);
  }

  protected getNumberPage(pageIndex = 0): string {
    return `page=${pageIndex}`;
  }

  protected getNumberRegistries(pageSize = 15): string {
    return `size=${pageSize}`;
  }

  protected mapEntity(data: any): any {
    const { entry } = data;
    return {
      ...entry
    };
  }

  private buildAxiosInstance(): Axios {
    const axiosInstance = Axios.create({});
    this.requestInterceptor(axiosInstance);
    this.responseInterceptor(axiosInstance);

    return axiosInstance;
  }

  private requestInterceptor(axios: Axios): void {
    axios.interceptors.request.use(
      (config: AxiosRequestConfig) => beneficiarioHandleRequest(config),
      (error: any) => beneficiarioHandleErrorRequest(error)
    );
  }

  private responseInterceptor(axios: Axios): void {
    axios.interceptors.response.use(
      (response: AxiosResponse) => handleResponse(response),
      (error: any) => handleErrorResponse(error)
    );
  }
}
